import { useEffect } from 'react';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  isFailure: boolean;
};

export const PaymentResult = ({ isFailure }: TProps) => {
  useEffect(() => {
    window?.top?.postMessage('3DS-authentication-complete');
  }, []);

  return (
    <Wrapper>
      <h2>{isFailure ? ' Payment failure' : 'Payment successful'}</h2>
      <p>
        {isFailure ? (
          <>
            Oh no, Your payment failed
            <br />
            Please update payment information.
          </>
        ) : (
          <>Thank You for Your Payment</>
        )}
      </p>
    </Wrapper>
  );
};
